import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { Form, Row, Col, Button } from 'react-bootstrap'
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobeAsia, faUsers } from '@fortawesome/free-solid-svg-icons'
import { Checkbox, HeaderTitle } from '../Library'
import { updateCalendar, getCalendar, addDepartmentEvent, removeDepartmentEvent } from '../Network/Calendar'
import { useHistory, useParams } from 'react-router-dom'
import { listCompany } from '../Network/Company'
import { listDepartment } from '../Network/Department'
import MultiSelect from "react-multi-select-component";
import { setDocumentTitle } from '../AppTitle'
import dayjs from 'dayjs'
import "./AddCalendar.css"
import { RoleContext } from '../Role/RoleContext'

function UpdateCalendar() {
    const { id } = useParams()
    const history = useHistory()
    const role = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"
    const langCx = useContext(LanguageContext)
    const notify = useContext(NotifyContext)
    const lang = langCx.lang.calendar
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [location, setLocation] = useState("")
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isAllday, setAllday] = useState(false)
    const [isHoliday, setHoliday] = useState(false)
    const [isYearly, setYearly] = useState(false)
    const [publication, setPublication] = useState(0)
    const [isError, setError] = useState(false)
    const [companyList, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const [departmentList, setDepartment] = useState([])
    const [prevSelectedDepartment, setPrevSelectedDepartment] = useState([])
    const [selectedDepartment, setSelectedDepartment] = useState([])

    const fetchCompany = () =>{
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{

            }
        )
    }

    const fetchDepartment = (companyId) =>{
        listDepartment(companyId,
            (data)=>{
                var list = []
                data.forEach((item)=>{
                    list.push({ label: item.name, value: item.id })
                })
                setDepartment(list)
            },
            (error)=>{

            })
    }

    const submit = () =>{
        let isGlobal = publication === 0 ? true:false 
        let type = isHoliday ? "HOLIDAY": "NORMAL"
        let start = dayjs(startDate).valueOf()
        let end = dayjs(endDate).valueOf()

        if(!title || !description || !location){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true)
            return;
        }else if((start > end) && !isAllday){
            notify.showNotify(lang.start_greater_than, lang.start_greater_than_desc, 1)
            setError(true)
            return;
        }

        updateCalendar(id, title, description, start, end, location, type, isGlobal, isAllday, isYearly,
            ()=>{
                addByDepartment(id)
                notify.showNotify(lang.updated_success, lang.updated_success_desc, 0)
                history.push("/calendar")
            },
            (error)=>{
                notify.showNotify("Something wrong submit", error.message, 2)
            })
    }

    const addByDepartment = (eventId) =>{
        selectedDepartment.forEach((item)=>{
            var eventItem = false
            if(!prevSelectedDepartment.find(el=>el.value === item.value)){
                eventItem = true
            }else{
                eventItem = false
            }
            
            if(eventItem){
                addDepartmentEvent(eventId, item.value,
                    ()=>{ },
                    (error)=>{
                        notify.showNotify("Something wrong adding department", error.message, 2)
                    })
            }
            
        })

        prevSelectedDepartment.forEach((item)=>{
            if(!selectedDepartment.find(el=>el.value === item.value)){
                removeDepartmentEvent(eventId, item.value,
                    ()=>{},
                    (error)=>{
                        notify.showNotify("Something wrong removing department", error.message, 2)
                    }
                )
            }
        })
    }

    const fetchData = () =>{
        getCalendar(id,
            (data)=>{
                console.log(data)
                setTitle(data.title)
                setDescription(data.description)
                setLocation(data.location)
                setPublication(data.global ? 0:1)
                setStartDate(data.eventStart)
                setEndDate(data.eventEnd)
                setAllday(data.allDay)
                setHoliday(data.type === "HOLIDAY" ? true:false)
                setYearly(data.repeat)
                if(!data.global){
                    if(data.departments.length > 0){
                        let companyId = data.departments[0].companyId
                        var departmentsList = []
                        data.departments.forEach((item)=>{
                            departmentsList.push({ label: item.name, value: item.id })
                        })
                        setSelectedCompany(companyId)
                        setSelectedDepartment(departmentsList)
                        setPrevSelectedDepartment(departmentsList)
                        fetchDepartment(companyId)
                    }
                    setPublication(1)
                
                }else{
                    setPublication(0)
                }
            },
            (error)=>{
                notify.showNotify("Something wrong submit", error.message, 2)
            })
    }

    useEffect(()=>{
        setDocumentTitle("Edit Calendar")
        fetchData()

        if(!role.checkPermission(prefixAuthority, companyAuthority)){
            fetchCompany()
            setPublication(1)
        }else if(!role.checkPermission(prefixAuthority, globalAuthority)){
            fetchCompany()
            setPublication(1)
        }else{
            fetchCompany()
        }
    },[])
   
    return (
        <div id="add-calendar">
            <HeaderTitle title={lang.edit_event} isShowBack backTo="/calendar"/>
            <div className="content-container">
                <Row>
                    <Col md={10} lg={8} xl={6}>
                        <Form
                        onSubmit={(e)=>{
                            e.preventDefault()
                            submit()
                        }}>
                            <Form.Group>
                                <Form.Label>{lang.title}</Form.Label>
                                <Form.Control
                                value={title}
                                onChange={(e)=>setTitle(e.target.value)}
                                isInvalid={isError && !title}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.description}</Form.Label>
                                <Form.Control as="textarea"
                                value={description}
                                onChange={(e)=>setDescription(e.target.value)}
                                isInvalid={isError && !description}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.location}</Form.Label>
                                <Form.Control
                                value={location}
                                onChange={(e)=>setLocation(e.target.value)}
                                isInvalid={isError && !location}
                                />
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                { role.checkPermission(prefixAuthority, globalAuthority) ?
                                <>
                                <Form.Label>{lang.publication}</Form.Label>
                                <div style={{display: "flex"}}>
                                    <PublishItem
                                    title={lang.public}
                                    icon={faGlobeAsia}
                                    isSelected={publication === 0 ? true:false}
                                    onClick={()=>setPublication(0)}/>
                                    <PublishItem
                                    title={lang.department}
                                    icon={faUsers}
                                    isSelected={publication === 1 ? true:false}
                                    onClick={()=>{
                                        fetchCompany()
                                        setPublication(1)
                                    }}/>
                                </div>
                                </>
                                : null
                                }
                                { publication === 1 ?
                                <div style={{marginTop: 10}}>
                                    <Form.Group>
                                        <Form.Label>{lang.company}</Form.Label>
                                        <Form.Control as="select"
                                        value={selectedCompany}
                                        disabled={!role.checkPermission(prefixAuthority, companyAuthority) ? true:false}
                                        onChange={(e)=>{
                                            let id = e.target.value
                                            setSelectedCompany(id)
                                            setDepartment([])
                                            setSelectedDepartment([])
                                            fetchDepartment(id)
                                        }}>
                                            <option value="">{lang.choose_company}</option>
                                            { companyList.map((item, key)=>
                                            <option key={key} value={item.id}>{item.name}</option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.department}</Form.Label>
                                        <MultiSelect
                                        disabled={selectedCompany === "" ? true:false}
                                        options={departmentList}
                                        value={selectedDepartment}
                                        onChange={setSelectedDepartment}
                                        />
                                    </Form.Group>
                                </div>
                                : null
                                }
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Form.Label>{lang.start_date}</Form.Label>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                    if(isAllday){
                                        setEndDate(date)
                                    }
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy - H:mm"
                                showTimeSelect/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.end_date}</Form.Label>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>setEndDate(date)}
                                className="form-control" 
                                dateFormat="d MMMM yyyy - H:mm"
                                disabled={isAllday}
                                showTimeSelect/>
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Checkbox
                                label={lang.all_day}
                                checked={isAllday}
                                onChange={()=>{
                                    setAllday(!isAllday ? true:false)
                                    setEndDate(startDate)
                                }}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Checkbox
                                label={lang.holiday}
                                checked={isHoliday}
                                onChange={()=>setHoliday(!isHoliday ? true:false)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Checkbox
                                label={lang.repeat_yearly}
                                checked={isYearly}
                                onChange={()=>setYearly(!isYearly ? true:false)}
                                />
                            </Form.Group>
                            
                            <hr/>
                            <Button type="submit">
                                {lang.save_change}
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

function PublishItem(props){
    return(
        <div className="publish-item"
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        onClick={props.onClick}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
                <div className="desc"
                style={{color: props.isSelected ? "white" : "gray"}}>
                    {props.desc}
                </div>
            </div>
        </div>
    )
}


export default UpdateCalendar